





















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { WorkshopService } from '@/core/services';
import {
  InputFieldCpt,
  InputSelectCpt,
  SubmitButtonCpt,
  BaseFormComponent,
  InputTextareaCpt,
} from '@/core/components/form';
import { SimpleLookupModel, WorkshopClientLookups, CompanyFormModel } from '@/core/models';
import _ from 'lodash';

@Component({
  components: {
    InputFieldCpt,
    InputSelectCpt,
    SubmitButtonCpt,
    InputTextareaCpt,
  },
})
export default class AddClientFormCpt extends BaseFormComponent {
  @Prop({ default: false }) loading: boolean;
  @Prop() workshopId: number;
  isSubmitButtonDisabled = false;
  submitInProgress = false;

  lookups = {
    counties: [] as SimpleLookupModel[],
    sectors: [] as SimpleLookupModel[],
  } as WorkshopClientLookups;

  model: CompanyFormModel = new CompanyFormModel();

  async onSubmitForm() {
    await WorkshopService.putWorkshopClient(this.workshopId, this.model);
    super.onSuccess(`/admin/workshops/${this.workshopId}/detail`);
  }

  async created() {
    await this.initializeLookups();
  }

  private async initializeLookups() {
    const lookups = await WorkshopService.getWorkshopClientLookups();
    _.extend(this.lookups, lookups);
  }
}
